<template>
    <div class="vrm-modal vrm-modal--wide mfp-with-anim">
        <div class="vrm-modal__header">
            <div class="vrm-modal__title">
                {{ $t('advanced.export_layout') }}
            </div>
        </div>
        <form class="vrm-modal__content" @submit.prevent="onSubmit" @reset.prevent="onReset">
            <fieldset class="vrm-fieldset">
                <div class="vrm-form__fieldset-item">
                    {{ $t('advanced.export_layout_explainer') }}
                </div>
            </fieldset>
            <fieldset class="vrm-fieldset">
                <div class="vrm-form__fieldset-item">
                    <vrm-dropdown-multiselect
                        v-model="targets"
                        :options="options"
                        :disabled="busy"
                        :search-enabled="true"
                    />
                </div>
            </fieldset>
            <br />
            <div class="sg-spread">
                <button type="reset" class="sg-btn sg-site" :disabled="busy">
                    {{ $t('common.cancel', { i18nFallback: 'Cancel' }) }}
                </button>
                <button type="submit" class="sg-btn sg-blue" :disabled="!canSubmit">
                    {{ $t('advanced.export_layout') }}
                </button>
            </div>
        </form>
        <modal-close-handle />
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import { ngInject } from '@/vue/decorators/angular-interop';
import VrmInstallationAvatar from '@/vue/components/shared/VrmInstallationAvatar';
import VrmDropdownMultiselect from '@/vue/components/shared/VrmDropdownMultiselect';

@Component({
    components: { VrmDropdownMultiselect, VrmInstallationAvatar, ModalCloseHandle },
})
export default class ExportWidgetLayoutModal extends Vue {
    @Prop()
    idSite;

    @ngInject()
    ApiService;
    @ngInject()
    InstallationsService;
    @ngInject()
    vrmInstallationAccessLevel;

    busy = false;
    /** @type {number[]} */
    targets = [];

    get options() {
        const sites = this.InstallationsService.installations || [];
        const taken = new Set(this.targets.map(site => site.id));
        return sites
            .filter(s => {
                const notSourceSite = s.id !== this.idSite;
                const hasWriteAccess = +s.view_permissions.update_settings === 1;
                const notYetPicked = !taken.has(s.id);
                return notSourceSite && hasWriteAccess && notYetPicked;
            })
            .map(site => ({
                id: site.id,
                name: site.name,
            }));
    }

    onSelect(site) {
        this.targets.push(site);
    }

    onRemove(site) {
        const index = this.targets.findIndex(s => s.id === site.id);
        this.targets.splice(index, 1);
    }

    get canSubmit() {
        return !this.busy && this.targets.length > 0;
    }

    async onSubmit() {
        if (!this.canSubmit) return;
        const payload = { sites: this.targets.map(site => site.id) };
        await this.ApiService.call2(`/installations/${this.idSite}/copy-widget-layout`, payload);
        this.$emit('close', true);
    }

    async onReset() {
        this.$emit('close', false);
    }
}
</script>
